import { Printer } from "lucide-react";

export default function PageHeader({ overline, title, description, actions, hidePrint = false }) {
  const handlePrint = () => {
    document.body.setAttribute("data-print-title", title || "SM Marine Products");
    window.print();
    // attribute stays; cleared on next print invocation. Safe to leave.
  };

  return (
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 sm:gap-6 mb-6 sm:mb-8 page-header">
      <div>
        {overline && (
          <div className="text-xs font-mono mb-2" style={{ color: "var(--brand-blue)" }}>
            // {overline}
          </div>
        )}
        <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight">{title}</h1>
        {description && (
          <p className="text-sm mt-2 max-w-2xl" style={{ color: "var(--text-muted)" }}>
            {description}
          </p>
        )}
      </div>
      <div className="flex gap-2 flex-shrink-0 flex-wrap items-center no-print">
        {actions}
        {!hidePrint && (
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handlePrint}
            data-testid="print-page-button"
            title="Print this page"
          >
            <Printer size={14} /> Print
          </button>
        )}
      </div>
    </div>
  );
}
